// axiosInstance.js
import axios from "axios";

let domain = "";

if (window.location.hostname === "localhost") {
  domain = process.env.REACT_APP_LOCAL_DJANGO;
} else if (window.location.hostname.trim() === "it.acuvisor.com") {
  domain = process.env.REACT_APP_PRODUCTION_DJANGO;
} else {
  domain = process.env.REACT_APP_UAT_DJANGO;
}

const axiosInstance = axios.create({
  baseURL: domain, // Replace with your API URL
  withCredentials: true, // This allows Axios to include cookies in requests
});

export default axiosInstance;
